const getHostname = () => (typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '');

export const isInterviewFlowDomain = () => getHostname().includes('interviewflow');

const isLocalhost = () => {
  const h = getHostname();
  return h === 'localhost' || h === '127.0.0.1';
};

const isBaiglabsDomain = () => getHostname().includes('baiglabs');

/** Hosts that still expose legacy builder URLs (deprecated; prefer Studio). */
export const isLegacyDomain = () => isBaiglabsDomain() || isLocalhost();

/**
 * Product experience label. Both BaigLabs and InterviewFlow use Studio V2 for flows/apps;
 * InterviewFlow remains the recruiting/permits/CRM umbrella brand.
 */
export const getDomainExperience = () => {
  if (isInterviewFlowDomain()) return 'v2';
  if (isBaiglabsDomain() || isLocalhost()) return 'v2';
  return 'legacy';
};

/** Legacy builders remain reachable on BaigLabs for old bookmarks; nav points at Studio. */
export const canAccessLegacyBuilders = () => isLegacyDomain();

/** Studio V2 is available on InterviewFlow, BaigLabs, and local/dev. */
export const canAccessV2Studio = () => isInterviewFlowDomain()
  || isBaiglabsDomain()
  || isLocalhost();

export const getExperienceLabel = () => (getDomainExperience() === 'v2' ? 'Studio V2' : 'Legacy Experience');

/** Canonical public Studio origin when a host cannot serve /studio (fallback only). */
export const getV2PublicOrigin = () => {
  const fromEnv = import.meta.env.VITE_V2_PUBLIC_ORIGIN;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://interviewflow.studio';
};
